module.exports = __webpack_public_path__ + "img/empty-state-icon.ece5bc87.svg";